'use client';

import { skipPwaScreenAtom, useIntl } from '@capsicum/common';
import { AnimatePresence, motion } from 'framer-motion';
import { useSetAtom } from 'jotai';

import { Button } from '../../atoms';

export const SkipPWA = () => {
	const { $t } = useIntl();
	const setSkipPWAScreenAtom = useSetAtom(skipPwaScreenAtom);

	return (
		<AnimatePresence>
			<motion.div
				animate={{ opacity: 1 }}
				initial={{ opacity: 0 }}
				transition={{
					delay: 3
				}}
			>
				<Button
					color="light"
					testID="skip-pwa-button"
					text={$t('pwa.instructions.skipForNow')}
					variant="outlined"
					onClick={() => setSkipPWAScreenAtom(true)}
				/>
			</motion.div>
		</AnimatePresence>
	);
};
